import { createSelector } from '@ngrx/store';
import { BoelsState, getStoreState } from '../../reducers.index';
import { ProductSearchState } from '../reducers/product-search.reducer';

export const selectProductSearchPageState = createSelector(
  getStoreState,
  (state: BoelsState) => state.productSearchState,
);

export const selectProductSearchPageEntities = createSelector(
  selectProductSearchPageState,
  (state: ProductSearchState) => state.entities,
);
